/**
 * Handle sizes sent from db and convert to bytes
 * @description Individual file sizes are sent in KB and file collection sizes are sent in MB
 * @param size size stored server side
 */
export function convertDbSizeToBytes(
  size: number,
  type: 'file' | 'collection'
): number {
  const marker = 1024;
  const power = type === 'file' ? 1 : type === 'collection' ? 2 : 0;
  return size * Math.pow(marker, power);
}
